import { _delete, _get, _post, _put } from "../CommonAxios"

const mapAllocatedGuests = (allocatedGuests) => (
    (allocatedGuests || [])
        .filter((guest) => (guest.firstName || "").trim() || (guest.lastName || "").trim())
        .map((guest) => {
            const mapped = {
                first_name: (guest.firstName || "").trim(),
                last_name: (guest.lastName || "").trim(),
            };
            if (guest.id) {
                mapped.id = guest.id;
            }
            return mapped;
        })
);


const getGuestByInviteCode = async (inviteCode) => {
    let guestCodeEventUrl = "latest/guest/rsvp/invite/?invitecode=" + inviteCode;
    let resp;
    try {
        resp = await _get(guestCodeEventUrl).then(result => result);
    } catch (err) {

    }
    return resp;
}

// const getGuestAllocatedAddtlGuest = async (inviteCode) => {
//     let guestCodeEventUrl = "rsvp/guest/addtional/allowed/?invitecode=" + inviteCode;
//     let resp;
//     try {
//         resp = await _get(guestCodeEventUrl).then(result => result);
//     } catch (err) {
//         
//     }
//     return resp;
// }

const getGuestConfirmedAddtlGuest = async (inviteCode) => {
    let guestCodeEventUrl = "rsvp/guest/addtional/confirm/?invitecode=" + inviteCode;
    let resp;
    try {
        resp = await _get(guestCodeEventUrl).then(result => result);
    } catch (err) {

    }
    return resp;
}


const getGuestResponse = async (inviteCode) => {
    let guestCodeEventUrl = "latest/guest/rsvp/confirm/?invitecode=" + inviteCode;
    let resp;
    try {
        resp = await _get(guestCodeEventUrl).then(result => result);
    } catch (err) {

    }
    return resp;
}

const sendGuestResponse = async (inviteCode, data) => {
    let guestCodeEventUrl = "latest/guest/rsvp/confirm/?invitecode=" + inviteCode;
    let resp;
    try {
        resp = await _post(guestCodeEventUrl, data).then(result => result);
    } catch (err) {

    }
    return resp;
}

const sendAddtlGuestConfirmation = async (inviteCode, data) => {
    let guestCodeEventUrl = "rsvp/guest/addtional/confirm/?invitecode=" + inviteCode;
    let resp;
    try {
        resp = await _post(guestCodeEventUrl, data).then(result => result);
    } catch (err) {

    }
    return resp;
}

const getAdminAllGuests = async (inviteCode, data) => {
    let apiUrl = "latest/guest/rsvp/confirm/";
    let resp;
    try {
        resp = await _get(apiUrl, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }).then(result => result.data);
    } catch (err) {
        window.location.href = '/login';
    };
    return resp;
}

const getAdminAllGuestInvites = async (inviteCode, data) => {
    let apiUrl = "latest/guest/rsvp/invite/";
    let resp;
    try {
        resp = await _get(apiUrl, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }).then(result => result.data);
    } catch (err) {
        window.location.href = '/login';
    };
    return resp;
}


const addGuest = async (body) => {
    let guestCodeEventUrl = "latest/guest/rsvp/invite/"
    let resp;
    const postBody = {
        allocated_guests: mapAllocatedGuests(body.allocatedGuests),
        first_name: body.firstName,
        last_name: body.lastName
    }

    try {
        resp = await _post(
            guestCodeEventUrl,
            postBody,
            {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                },
            },

        ).then((result) => result);
    } catch (err) {
        throw err;
    }
    return resp;
}

const updateGuest = async (id, body) => {
    let guestCodeEventUrl = "latest/guest/rsvp/invite/" + id + "/";
    const postBody = {
        allocated_guests: mapAllocatedGuests(body.allocatedGuests),
        first_name: body.firstName,
        last_name: body.lastName
    };

    return _put(
        guestCodeEventUrl,
        postBody,
        {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
        },
    );
}

const deleteGuest = async (id) => {
    const guestCodeEventUrl = "latest/guest/rsvp/invite/" + id + "/";
    return _delete(guestCodeEventUrl, {
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
        },
    });
}

export {
    getGuestByInviteCode,
    // getGuestAllocatedAddtlGuest,
    getGuestResponse,
    sendGuestResponse,
    getGuestConfirmedAddtlGuest,
    sendAddtlGuestConfirmation,
    getAdminAllGuests,
    getAdminAllGuestInvites,
    addGuest,
    updateGuest,
    deleteGuest,
};